module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback4-8f214a3530bb3bacf827a9dbf21589d4.jpg";